__turbopack_context__.v({
  "iconHover": "y7unLW_iconHover",
  "iconIdle": "y7unLW_iconIdle",
  "iconWrapDual": "y7unLW_iconWrapDual",
  "item": "y7unLW_item",
  "itemActive": "y7unLW_itemActive",
  "itemDisabled": "y7unLW_itemDisabled",
  "itemIndicator": "y7unLW_itemIndicator",
  "items": "y7unLW_items",
  "itemsPrimary": "y7unLW_itemsPrimary",
  "itemsSecondary": "y7unLW_itemsSecondary",
  "label": "y7unLW_label",
  "sideNavToggleGlyph": "y7unLW_sideNavToggleGlyph",
  "sideNavToggleGlyphExpanded": "y7unLW_sideNavToggleGlyphExpanded",
  "sideNavToggleIconButton": "y7unLW_sideNavToggleIconButton",
  "sideNavToggleOnly": "y7unLW_sideNavToggleOnly",
  "sidenav": "y7unLW_sidenav",
  "submenu": "y7unLW_submenu",
  "submenuItem": "y7unLW_submenuItem",
  "submenuItemActive": "y7unLW_submenuItemActive",
  "userActionItem": "y7unLW_userActionItem",
  "userIdentity": "y7unLW_userIdentity",
  "userMenuButton": "y7unLW_userMenuButton",
  "userName": "y7unLW_userName",
  "userRole": "y7unLW_userRole",
  "userSection": "y7unLW_userSection",
  "userSectionRow": "y7unLW_userSectionRow",
  "userSectionTop": "y7unLW_userSectionTop",
});
